<template>
  <DxPopup
      content-template="popup-content-industry"
      :visible="visible"
      :close-on-outside-click="false"
      :width="600"
      :height="600"
      :drag-enabled="false"
      :title="title"
  >
    <DxToolbarItem
        widget="dxButton"
        toolbar="top"
        location="after"
        :options="clearIndustryButtonOptions"
    />

    <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmIndustryButtonOptions"
    />

    <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="closeIndustryButtonOptions"
    />

    <template #popup-content-industry>
      <div style="display: flex;gap: 0">
        <DxScrollView width="50%" height="100%" v-if="shouldRenderLeftScrollView">
          <p v-for="(item, index) in industry" :key="index">
            <DxCheckBox
                :text="item"
                :value="false"
                @valueChanged="onIndustryValueChange"
            >
            </DxCheckBox>
          </p>
        </DxScrollView>

        <DxScrollView width="50%" height="100%" v-if="shouldRenderRightScrollView">
          <p v-for="(item, index) in selectedIndustry" :key="index">
            {{item}}
          </p>
        </DxScrollView>
      </div>
    </template>
  </DxPopup>

</template>

<script>
import nationalStandardIndustryCategories from "@/js/industryCategories"

export default {
  name: "IndustrySelector",
  props: {
    visible : {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '国标行业选择'
    }
  },
  data(){
    return {
      shouldRenderLeftScrollView: true,
      shouldRenderRightScrollView: true,
      industry: [],
      selectedIndustry: [],
      closeIndustryButtonOptions: {
        text: '取消',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: () => {
          this.$emit('cancel');
        },
      },
      confirmIndustryButtonOptions: {
        text: '确定',
        stylingMode: 'outlined',
        onClick: () => {
          /*

          this.isIndustryPopupVisible = false*/
          this.$emit('confirm');
        },
      },
      clearIndustryButtonOptions : {
        text: '清空',
        stylingMode: 'outlined',
        onClick: () => {
          this.clear()
        },
      },
    }
  },
  created() {
    this.industry = nationalStandardIndustryCategories;
  },
  methods: {
    onIndustryValueChange(e){
      this.shouldRenderRightScrollView = false
      const value = e.component._props.text
      if(e.value) {
        this.selectedIndustry.push(value)
      } else {
        this.selectedIndustry = this.selectedIndustry.filter(element => element !== value)
      }
      this.$nextTick(() => {
        this.shouldRenderRightScrollView = true
      })
      this.getSelectedIndustry()
    },
    clear(){
      this.shouldRenderLeftScrollView = false
      this.$nextTick(() => {
        this.shouldRenderLeftScrollView = true
      })
      this.selectedIndustry = []
      this.getSelectedIndustry()
    },
    getSelectedIndustry(){
      this.$emit('selectChange', this.selectedIndustry)
    }
  }
}
</script>

<style scoped>

</style>


